function Projects(props) {
    return(
        <div class="main">
            <h1>Projects</h1>
            <div>
                <h2>Fish Problems</h2>
                <img class="screenshot" src="https://camo.githubusercontent.com/ced9909a641a4d15f35f360aea2e14c3c81300a9a8427cb2b9acf4ca82c623a3/68747470733a2f2f627261646c65796d61746865722e636f6d2f77702d636f6e74656e742f75706c6f6164732f323032322f30372f53637265656e2d53686f742d323032322d30372d31392d61742d372e33382e30302d504d2e706e67" alt="screenshot"/> <br/> <br/>
                <a class="projlink" href="https://capstone.bradleymather.com/" target="_blank" rel="noreferrer">View Live App</a>
                <a class="projlink" href="https://github.com/bmather02/fish-problems-front-end" target="_blank" rel="noreferrer">View Repository</a>
                <h3>Technologies Used</h3>
                <ul>
                    <li>JavaScript</li>
                    <li>Node.js</li>
                    <li>MongoDB</li>
                    <li>Express</li>
                    <li>React</li>
                    <li>Skeleton CSS framework</li>
                    <li>Ruby</li>
                    <li>Rails</li>
                    <li>PostgreSQL</li>
                    <li>HTML5</li>
                    <li>CSS3</li>
                </ul>
                <h3>Description</h3>
                <p>Problems with your aquarium? look no further than Fish Problems! Fish Problems is a React web application that pulls from two separate back ends because why not?</p>
            </div>
            <br/>
            <br/>
            <div>
                <h2>STEPSHEETS</h2>
                <img class="screenshot" src="https://camo.githubusercontent.com/ceb072245c5228cee23c1752857b51a4cab75c80820065620cdffa58c75c4751/68747470733a2f2f627261646c65796d61746865722e636f6d2f77702d636f6e74656e742f75706c6f6164732f323032322f30372f53637265656e2d53686f742d323032322d30372d31342d61742d312e30302e35362d414d2e706e67" alt="screenshot"/> <br/> <br/>
                <a class="projlink" href="https://stepsheets.herokuapp.com/" target="_blank" rel="noreferrer">View Live App</a>
                <a class="projlink" href="https://github.com/bmather02/STEPSHEETS" target="_blank" rel="noreferrer">View Repository</a>
                <h3>Technologies Used</h3>
                <ul>
                    <li>Python</li>
                    <li>Django</li>
                    <li>PostgreSQL</li>
                    <li>HTML5</li>
                    <li>CSS3</li>
                </ul>
                <h3>Description</h3>
                <p>STEPSHEETS is a new and improved line dance step sheet database. This web application allows users to sear for and view line dance step sheets, view videos associated with line dances, and view all dances by a specific choreographer.</p>
            </div>
            <br/>
            <br/>
            <div>
                <h2>StreepFlix</h2>
                <img class="screenshot" src="https://camo.githubusercontent.com/5e4cf7e2d42d5cd4af729c4c64391d32cb37c8b964e168cf7c21750f9afb1b21/68747470733a2f2f692e696d6775722e636f6d2f3357544b3274312e6a7067" alt="screenshot"/> <br/> <br/>
                <a class="projlink" href="https://streepflix.netlify.app/" target="_blank" rel="noreferrer">View Live App</a>
                <a class="projlink" href="https://github.com/bmather02/streepflix-frontend" target="_blank" rel="noreferrer">View Repository</a>
                <h3>Technologies Used</h3>
                <ul>
                    <li>JavaScript</li>
                    <li>React</li>
                    <li>Node.js</li>
                    <li>Express</li>
                    <li>MongoDB</li>
                    <li>HTML5</li>
                    <li>CSS3</li>
                    <li>TMDB API</li>
                </ul>
                <h3>Description</h3>
                <p>Welcome to Streepflix! An app inspired by Netflix that delivers something you're desperately missing: A streaming service exclusively for Meryl Streep movies.</p>
                <p>Streepflix is MERN app that models user data and pulls info from the TMDB API to give a user a comprehensive list of Meryl Streep movies to choose from. You can watch trailers, read plot summaries, and compile a personal watch list of your favorites.</p>
            </div>
            <br/>
            <br/>
            <div>
                <h2>Event Staffr</h2>
                <img class="screenshot" src="https://camo.githubusercontent.com/a63553479b2d3faf30ac321b21f458fde190b1e059a2f5d2147fdb2d57b8824f/68747470733a2f2f627261646c65796d61746865722e636f6d2f77702d636f6e74656e742f75706c6f6164732f323032322f30362f53637265656e2d53686f742d323032322d30362d30322d61742d332e31352e31342d504d2d322e706e67" alt="screenshot"/> <br/> <br/>
                <a class="projlink" href="https://event-staffr.herokuapp.com/" target="_blank" rel="noreferrer">View Live App</a>
                <a class="projlink" href="https://github.com/bmather02/event-staffr" target="_blank" rel="noreferrer">View Repository</a>
                <h3>Technologies Used</h3>
                <ul>
                    <li>JavaScript</li>
                    <li>Node.js</li>
                    <li>Mongoose</li>
                    <li>MongoDB</li>
                    <li>Express.js</li>
                    <li>EJS</li>
                    <li>HTML5</li>
                    <li>CSS3</li>
                </ul>
                <h3>Description</h3>
                <p>Event-Staffr is a staff management and planning web application designed to allow event directors of the United Country Western Dance Council to streamline the process of finding available judges, teachers, and administrative assistants.</p>
            </div>
            <br/>
            <br/>
            <div>
                <h2>Chicago Hearts The Earth</h2>
                <img class="screenshot" src="https://github.com/bmather02/Chicago-Hearts-The-Earth/raw/master/Images/Screen%20Shot%202022-05-12%20at%202.25.05%20PM%20(2).png" alt="screenshot"/> <br/> <br/>
                <a class="projlink" href="https://sage-selkie-3c1f91.netlify.app/" target="_blank" rel="noreferrer">View Live App</a>
                <a class="projlink" href="https://github.com/bmather02/Chicago-Hearts-The-Earth" target="_blank" rel="noreferrer">View Repository</a>
                <h3>Technologies Used</h3>
                <ul>
                    <li>HTML5</li>
                    <li>CSS3</li>
                    <li>JavaScript</li>
                    <li>jQuery</li>
                    <li>AJAX</li>
                </ul>
                <h3>Description</h3>
                <p>This project serves as a resource to display environment and sustainable development data. Data taken from The City of Chicago Data Portal.</p>
            </div>
        </div>
        )
}
export default Projects